import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import store from "./redux/store/index";
import Routes from "./router/index";
import "./App.css";
import NetworkService from "./services/network";
import SnackBar from "./components/snackbar";
import Loader from "./components/loader";
// import AxiosInterceptorComponent from "./services/network"
NetworkService.setupInterceptors();
function App() {
  useEffect(() => {
    const disableContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", disableContextMenu);

    return () => {
      document.removeEventListener("contextmenu", disableContextMenu);
    };
  }, []);

  useEffect(() => {
    const disableDevTools = (e) => {
      if (e.key === "F12") {
        e.preventDefault();
      }
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === "I") {
        e.preventDefault();
      }
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === "C") {
        e.preventDefault();
      }
      if ((e.ctrlKey || e.metaKey) && e.key === "U") {
        e.preventDefault();
      }
    };
    window.addEventListener("keydown", disableDevTools);
    return () => {
      window.removeEventListener("keydown", disableDevTools);
    };
  }, []);
  return (
    <>
      <Provider store={store}>
        {/* <AxiosInterceptorComponent /> */}
        <Routes />
        <Loader />
        <SnackBar />
      </Provider>
    </>
  );
}

export default App;
